import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from '@core/services/snackbar.service';
import { DriverService } from '@modules/policy/services/driver/driver.service';
import { FormService } from '@modules/policy/services/shared/form.service';
import { PolicyDataService } from '@modules/policy/services/shared/policy-data.service';
import { SaveService } from '@modules/policy/services/shared/save.service';
import { FormComponent } from '@modules/policy/shared/components/form/form.component';
import { handleValidations } from '@modules/policy/shared/rules/handle-validations.rules';
import { ClientSearchOptions } from '@shared/models/client-search-options.model';
import { of } from 'rxjs';

@Component({
  selector: 'app-driver-details',
  templateUrl: './driver-details.component.html',
  styleUrls: ['./driver-details.component.scss']
})
export class DriverDetailsComponent implements OnInit {

  searchForm = new FormGroup({});
  private _contactKey = null;
  form: FormGroup;
  formName: string;
  lob: string
  nodeId
  policyId
  options: ClientSearchOptions;
  customerNumIsEmpty: boolean;
  addAsDriverEnabled: boolean = true; // Always true for driver tab
  @ViewChild("formComponent", { static: false }) formComponent: FormComponent;
  
  constructor(
    public policyDataService: PolicyDataService,
    private driverService: DriverService,
    private route: ActivatedRoute,
    private SaveService: SaveService,
    private FormService: FormService,
    private snackbar: SnackbarService
  ) { }

  set clientKey(newKey: string | null) {
    if (newKey) {
      this.form.disable(), this.searchForm.disable();
    } else {
      this.form.enable(), this.searchForm.enable();
    }
    this._contactKey = newKey
  }

  get clientKey() {
    return this._contactKey;
  }

  ngOnInit() {
    this.policyId = Number(this.policyDataService.getPolicyID());
  }

  searchFormCreated(searchForm: FormGroup) {
    this.searchForm = searchForm;
    if (this.clientKey) {
      this.searchForm.disable();
      this.form?.get('EnableDriverSearch')?.disable();
    }
  }

  driverFound(driverData: Object) {
    const infoForm = this.form.controls[this.formName] as FormGroup;
    for (const [fieldName, value] of Object.entries(driverData)) {
      if (!infoForm.contains(fieldName)) continue;
      infoForm.get(fieldName).setValue(value);
    }
    this.form.markAsDirty();
  }

  onCustomerNumChange(event: { value: any, isEmpty: boolean }) {
    this.customerNumIsEmpty = event.isEmpty;
  }

  canDeactivate() {
    return of(true).toPromise();
  }

  saveBeforeDeactivate() {
    if (this.FormService.doesFormExist(Number(this.nodeId))) {
      const formRawValues = this.form?.getRawValue() ?? {};
      return this.form?.dirty || this.form?.disabled ?
        Promise.all([
          this.SaveService.updatePolicy(this.policyId, formRawValues, this.nodeId).toPromise(),
          this.formComponent.saveBeforeDeactivate()
        ]) :
        this.formComponent.saveBeforeDeactivate();
    } else {
      return of(null).toPromise();
    }
  }

  showSaveSnackbar() {
    this.formComponent.showSaveSnackbar();
  }

  initForm(form: FormGroup) {
    this.form = form;
    this.nodeId = Number(this.route.snapshot.params["formId"]);
    this.formName = "DriverInformation"
    this.options = {
      sectionTitle: 'Contact Search',
      objectName: 'contact',
      clientReturnKeys: {
        clientKey: 'DriverContactSearchCd',
        contactReturnKey: 'SearchContactSearchCd',
        addressKey: 'SearchContactAddressPostalTxt',
        nameKey: 'SearchContactNameTxt',
      },
      formFields: {
        formName: this.formName,
        firstNameField: 'DriverFirstNameTxt',
        lastNameField: 'DriverLastNameTxt',
        postalCodeField: 'DriverAddressPostalTxt'
      },
      service: this.driverService
    }
    const cachedForm = this.policyDataService.getValueFromCache(this.nodeId);
    if (cachedForm && (cachedForm[this.options.clientReturnKeys.clientKey] || cachedForm.DriverStatusCd === "C")) {
      this.clientKey = cachedForm[this.options.clientReturnKeys.clientKey];
    } else {
      this.clientKey = null;
    }
    if (this.formComponent) handleValidations(this.formComponent.formjson, this.form);
  }

  setClientKey(newClientKey: string) {
    this.clientKey = newClientKey;
    this.formComponent.saveBeforeDeactivate();
  }

  save() {
    this.saveBeforeDeactivate().then(res => {
      if (res) this.showSaveSnackbar();
    })
  }
}
